export function addToCart({ supermodelId, skuId, quantity, analytics = {} }) {
  return new Promise((resolve, reject) => {
    cube.ajax
      .form(
        'rest/model/atg/commerce/order/purchase/CartModifierActor/addItemToOrder',
        {
          quantity,
          catalogRefIds: skuId,
          productId: supermodelId,
          commerceItemAttributes: JSON.stringify(analytics),
        }
      )
      .onSuccess(response => resolve(response.responseTO))
      .onError(reject)
      .call();
  });
}

/**
 * Update a commerce item quantity inside the cart :
 *
 * - updateQuantity({ id: 'ci12345678' , quantity: 1 })
 */
export function updateQuantity({ id, quantity }) {
  return new Promise((resolve, reject) => {
    cube.ajax
      .form(
        'rest/model/atg/commerce/order/purchase/CartModifierActor/setOrderByCommerceId',
        { [id]: quantity }
      )
      .onSuccess(resolve)
      .onError(reject)
      .call();
  });
}

/**
 * Confirming a product modification,
 * replace the old product by the selected new one :
 *
 * - replaceProductInCart(params)
 * - params = { removalCommerceIds, catalogRefIds, productId, quantity, index, commerceItemAttributes }
 */
export function replaceProductInCart(params) {
  return new Promise((resolve, reject) => {
    cube.ajax
      .form(
        'rest/model/atg/commerce/order/purchase/CartModifierActor/removeAndAddItemToOrder',
        params
      )
      .onSuccess(resolve)
      .onError(reject)
      .call();
  });
}

/**
 * Remove a commerce item from the cart :
 *
 * - removeProduct({ id: 'ci12345678' })
 */
export function removeProduct({ id }) {
  return new Promise((resolve, reject) => {
    cube.ajax
      .form(
        'rest/model/atg/commerce/order/purchase/CartModifierActor/removeItemFromOrder',
        { removalCommerceIds: [id] }
      )
      .onSuccess(resolve)
      .onError(reject)
      .call();
  });
}

/**
 * Move a product from cart to buylater list :
 *
 * - await fromCartToBuyLater({ itemIds, giftlistId })
 */
export function fromCartToBuyLater({ itemIds, giftlistId }) {
  return new Promise((resolve, reject) => {
    cube.ajax
      .form(
        'rest/model/com/decathlon/cube/commerce/gifts/BuyLaterActor/moveItemsFromCart',
        { itemIds, giftlistId }
      )
      .onSuccess(resolve)
      .onError(reject)
      .call();
  });
}

/**
 * Move a product from buylater list to cart :
 *
 * - await fromBuyLaterToCart(params)
 * - params = { catalogRefIds, productId, giftlistId, giftlistItemId, quantity, commerceItemAttributes }
 */
export function fromBuyLaterToCart(params) {
  return new Promise((resolve, reject) => {
    cube.ajax
      .form(
        'rest/model/com/decathlon/cube/commerce/gifts/BuyLaterActor/moveItemsToCart',
        params
      )
      .onSuccess(resolve)
      .onError(reject)
      .call();
  });
}

/**
 * Remove a product from buylater list :
 *
 * - await removeFromBuyLater({ removeGiftitemIds: 'gi4940475', giftlistId: 'gl35252254' })
 */
export function removeFromBuyLater({ giftlistId, removeGiftitemIds }) {
  return new Promise((resolve, reject) => {
    cube.ajax
      .form(
        removeGiftitemIds // if there is a 'itemId', remove only 1; else, remove all (2 differents URLs...)
          ? 'rest/model/com/decathlon/cube/commerce/gifts/BuyLaterActor/removeItemFromBuyLater'
          : 'rest/model/com/decathlon/cube/commerce/gifts/BuyLaterActor/removeItemsFromBuyLater',
        { removeGiftitemIds, giftlistId }
      )
      .onSuccess(resolve)
      .onError(reject)
      .call();
  });
}

/**
 * Try to validate a coupon filled by the user :
 *
 * - const response = await claimCoupon({ couponClaimCode, dateFormat, 'g-recaptcha-response' })
 */
export function claimCoupon(params) {
  return new Promise((resolve, reject) => {
    cube.ajax
      .form(
        'rest/model/com/decathlon/cube/commerce/pricing/promotion/claimable/ClaimableActor/claimCoupon',
        params
      )
      .onSuccess(resolve)
      .onError(reject)
      .call();
  });
}



// WEBPACK FOOTER //
// ./src/commons/api/cart-actions.js